<template>
	<div class="flex gap-2 text-center">
		<div v-if="priceSuggestions.length == 0" class="flex-1 bg-grey-11 rounded cursor-pointer p-1">
			<Loader size_prop="1em" borderSize_prop="0.3em" />
		</div>
		<div v-else v-for="(item, index) in priceSuggestions" v-bind:key="`${index}${item.shown}`"
			class="flex-1 bg-grey-11 rounded cursor-pointer p-1" @click="usePrice(item.value)">
			{{ item.shown }}
		</div>
	</div>
</template>

<script>
import { Decimal } from 'decimal.js'
import tradingFormulaSdk from '@bei/trading-formula'

import utils from '../../../utils'

import Loader from '../../Loader.vue'

export default {
	name: 'PriceSuggestions',

	components: {
		Loader
	},

	props: {
		contractId: [Number, String],
		direction: String,
		orderType: String,
	},

	data() {
		return {
			/** @type {{ value: string | number, shown: string }[]} */
			priceSuggestions: [],
		}
	},

	computed: {
		currency() {
			return this.$store.state.currency
		},

		contractConfigs() {
			return this.$store.getters.getContractConfigs(this.contractId)
		},

		gramSuggestions() {
			return this.contractConfigs.gramSuggestions
		},

		pricePerGramUsd() {
			const gold = this.$store.state.golds[this.contractId]

			if (!gold) return 0

			if (this.direction == 'sell') {
				return gold.pricePerGramSell2Decimal
			} else {
				return gold.pricePerGramBuy2Decimal
			}
		}
	},

	watch: {
		currency() {
			this.calculatePriceSuggestions()
		},
		pricePerGramUsd() {
			this.calculatePriceSuggestions()
		},
	},

	created() {
		this.calculatePriceSuggestions()
	},

	methods: {
		calculatePriceSuggestions() {
			let priceSuggestionsTemp = []
			this.gramSuggestions.forEach((gram) => {
				const quantity = Decimal.div(gram, this.contractConfigs.weightInGram).toNumber()

				const contractValue = tradingFormulaSdk.tradeTicket.getContractValue({
					pricePerGramUsd: this.pricePerGramUsd,
					contractWeight: this.contractConfigs.weightInGram,
					quantity: quantity,
					direction: this.direction,
					currency: 'usd',
				})

				const streamingRate = this.$store.getters.streamingRateByDirection(this.direction)

				let totalPrice = tradingFormulaSdk.tradeTicket.getTotal({
					paymentMethod: this.$store.getters.paymentMethod,
					contractValueUsd: contractValue,
					direction: this.direction,
					orderType: this.orderType,
					currency: this.currency,
					rateUsdToCurrency: streamingRate,
				})

				// console.log('WKWKWK', '\n'
				// 	+ 'gram: ', gram, '\n'
				// 	+ 'quantity: ', quantity, '\n'
				// 	+ 'pricePerGramUsd: ', this.pricePerGramUsd, '\n'
				// 	+ 'contractValue: ', contractValue, '\n'
				// 	+ 'streamingRate: ', streamingRate, '\n'
				// 	+ 'totalPrice: ', totalPrice
				// )

				// Round UP to nearest 10000 for IDR and 1 for USD
				const roundUpToNearest = this.currency == 'idr' ? 10000 : 1
				totalPrice = new Decimal(totalPrice).div(roundUpToNearest).ceil().times(roundUpToNearest)

				priceSuggestionsTemp.push({
					value: totalPrice.toNumber(),
					shown: utils.currencyFormat(totalPrice.toFixed())
				})
			})

			this.priceSuggestions = priceSuggestionsTemp
		},

		usePrice(price) {
			this.$emit('usePrice', price)
		},
	},
}
</script>